import BaseService from "./base.service";

export default class CategoryService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getCategoryById = (id, query) => {
        return this.get(`/product-category/${id}`, query)
    }

    getProductCategoryHome = (query) => {
        return this.get('/product-category', query)
    }

    /**
     * Lấy danh sách dịch vụ cho website
     * @param {Object} query - Query parameters
     * @param {string} query.locale - Locale (vn/en)
     * @param {number} query.business_id - Business ID (tùy chọn)
     * @param {number} query.department_id - Department ID (tùy chọn)
     * @param {number} query.limit - Số lượng kết quả (mặc định 10)
     * @returns {Promise}
     */
    getProductCategoryForWeb = (query) => {
        return this.get('/product-category/web/list', query)
    }
}